import { render, staticRenderFns } from "./SaleOrderSupply.vue?vue&type=template&id=174ae845"
import script from "./SaleOrderSupply.vue?vue&type=script&lang=js"
export * from "./SaleOrderSupply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports